<template>
    <div class="quiz-container">
        <div class="quiz-content">
            <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBack">{{className}}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>小测列表</el-breadcrumb-item>
            </el-breadcrumb> -->
            <div style="color: #8F8F8F; margin-bottom: 24px;">
                当前位置：
                <span @click="goBackTwo" v-if="role == 3">班级管理 > </span>
                <span @click="goBack">{{ className }}</span>
                <span> > 小测列表</span>
            </div>
            <div class="quiz-list">
                <div style="color: #000; font-size: 24px; display: flex; align-items: center;">
                    <div style="width: 6px; height: 32px; background: #006EFF; border-radius: 4px; margin-right: 10px;"></div>
                    小测列表
                </div>
                <div class="course-list" v-if="!recordId">
                    <span class="select-text">课程筛选：</span>
                    <el-select v-model="courseValve" placeholder="请选择" clearable @change="selectCourse" style="width: 300px;">
                        <el-option v-for="courseItem in courseList" :key="courseItem.course_id" :label="courseItem.course_name" :value="courseItem.course_id"></el-option>
                    </el-select>
                    <el-button  type="primary" style="float: right;" @click="goBack">返 回</el-button>
                </div>
                <el-table :data="quizList" style="width: 100%; flex: 1; margin-top: 20px;  border: 1px solid #EBEEF5; border-bottom: none; border-radius: 4px;" stripe :header-cell-style="headStyle" :cell-style="cellStyle">
                    <el-table-column prop="paper_name" label="试卷名称" width="220">
                      <template slot-scope="scope">
                        <span class="text-overflow">{{scope.row.paper_name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="t_name" label="创建人"></el-table-column>
                    <el-table-column label="提交状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.is_submit === 1">已提交</span>
                            <span v-else-if="scope.row.is_submit === 0">未提交</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="批阅状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.is_read === 0">已批阅</span>
                            <span v-else-if="scope.row.is_read === 1">未批阅</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="issue_time" label="发布时间" width="180"></el-table-column>
                  <el-table-column prop="end_time" label="结束时间" width="180"></el-table-column>
                  <el-table-column prop="status" label="是否结束">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status === 1">已结束</span>
                      <span v-else-if="scope.row.status === 0">未结束</span>
                    </template>
                  </el-table-column>
                    <el-table-column label="详情" width="100">
                        <template slot-scope="scope">
                            <el-link type="primary" :disabled="scope.row.status === 0" @click="toQuizDetail(scope.row)" :underline="false" style="color: #006EFF">查看详情</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination class="pages-center" background style="margin: 20px 0;"
                               :current-page.sync="quizPages.currentPageNum"
                               :page-size="quizPages.eachPageNum"
                               :total="quizPages.total"
                               layout="prev, pager, next, jumper"
                               @current-change="quizCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                role: localStorage.getItem('role'),
                classId: Number(this.$route.query.classId) || '',
                className: this.$route.query.className || '',
                recordId: Number(this.$route.query.recordId) || '',
                courseValve: '',
                courseList: [],
                quizList: [],
                quizPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                studentName: localStorage.getItem('sUsername'),
                studentId: Number(localStorage.getItem('s_id')),
            }
        },
        mounted() {
            this.getCourseList();
            // this.getQuizList();
        },
        methods: {
            headStyle() {
                return 'background: #F2F4F7; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;'
            },
            cellStyle() {
                return 'padding-left: 24px; height: 60px; color: #333;'
            },
            getCourseList() {
                let params = {
                    parent_id: 'no',
                    type: 1,
                    sort: 1
                }
                this.$shttp.axiosGetBy(this.$api.admin_courseLists, params, (res) => {
                    if (res.code === 200) {
                        this.courseList = res.list;
                        this.courseValve = res.list[0].course_id;
                        if (this.courseValve) {
                            this.getQuizList();
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            selectCourse(val) {
                this.getQuizList();
                this.courseValve = val;
            },
            getQuizList() {
                let params = {
                    c_id: this.classId,
                    page: this.quizPages.currentPageNum,
                    limit: this.quizPages.eachPageNum,
                    course_id: this.courseValve
                }
                if (this.recordId) {
                    params.course_record_id = this.recordId;
                }
                this.$shttp.axiosGetBy(this.$api.seeStudentQuizList, params, (res) => {
                    if (res.code === 200) {
                        this.quizList = res.data.data;
                        this.quizPages.total = res.data.total
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            quizCurrentChange(val) {
                this.quizPages.currentPageNum = val;
                this.getQuizList();
            },
            toQuizDetail(row) {
                if (row.is_submit === 0) {
                    let routeUrl = this.$router.resolve({
                        path: '/course/PaperDetail',
                        query: {
                            id: row.quiz_id,
                        }
                    })
                    window.open(routeUrl .href, '_blank')
                } else if (row.is_submit === 1) {
                    if (row.is_read === 1) {
                        this.$router.push({
                            path: '/teacherClass/approvedDetail',
                            query: {
                                quizId: row.quiz_id,
                                studentId: this.studentId,
                                classId: this.classId,
                                className: this.className,
                                paperName: row.paper_name,
                                studentName: this.studentName,
                            }
                        })
                    } else if (row.is_read === 0) {
                        this.$router.push({
                            path: '/teacherClass/allApprovedDetail',
                            query: {
                                quizId: row.quiz_id,
                                studentId: this.studentId,
                                classId: this.classId,
                                className: this.className,
                                paperName: row.paper_name,
                                studentName: this.studentName,
                            }
                        })
                    }
                }
            },
            goBack() {
                this.$router.go(-1)
            },
            goBackTwo() {
                this.$router.go(-2)
            },
        }
    }
</script>

<style scoped lang="scss">
    ::v-deep .el-breadcrumb {
        .el-breadcrumb__inner {
            color: #000;
        }
    }
    .quiz-container {
        width: 100%;
        height: calc(100% - 60px);
        padding: 30px 0;
        .quiz-content {
            width: 1200px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            .quiz-list {
                display: flex;
                flex-direction: column;
                height: calc(100% - 106px);
                padding: 32px 50px;
                background: #fff;
                .course-list {
                    padding: 20px 0 0 0;
                }
            }
        }
    }
</style>